module.exports = __webpack_public_path__ + "static/biennale-medium-e170585366c222f17e07ac7053553d8a.otf";